export const labels = {
  it: {
    label: {
      quotation: 'Richiedi preventivo',
      contactUsToConfigureExpositor: 'Contattaci per configurare il tuo espositore',
      back: 'Indietro',
      selectProduct: 'Seleziona un prodotto',
      selectAProduct: 'Seleziona il prodotto che ti interessa per iniziare la configurazione guidata',
      selectAProductDescription: "Scegli il prodotto dall'elenco a sinistra, clicca sul bottone qui sotto, completa il form con le informazioni richieste e ricevi il tuo preventivo",
      start: 'Configura ora',
      quotationSentTitle: 'Richiesta inviata con successo',
      quotationSent: 'Grazie per averci contattato. Le risponderemo nonappena possibile'
    },
    questions: {
      measure: 'Scegli la misura della scatola',
      internalOrExternalSizes: 'Le misure indicate sono?',
      boxOpening: "Scegli l'apertura",
      printType: 'Scatola neutra o con stampa?',
      supports: 'Vuoi i supporti interni?',
      boxAmount: 'Quanti prodotti desideri',
      expositorType: 'Scegli il tipo di espositore',
      additionalNotes: 'Annotazioni particolari',
      email: 'Inserisci e-mail',
      color: 'Scegli il colore della scatola',
      boxType: 'Scegli il tipo di cartone',
      alveolar: 'Alveari',
      bottleAmount: 'Numero di bottiglie',
      bottleSize: 'Dimensioni della bottiglia da imballare',
      measureCorner: 'Scegli le dimensioni che desideri'
    },
    products: {
      'american-box': 'Scatole americane',
      'punched-box': 'Scatole fustellate',
      'bottle-box': 'Scatole per bottiglie',
      'coat-hanger-box': 'Scatole appendiabiti',
      'litographed-box': 'Scatole litografate',
      expositor: 'Espositori',
      'corrugated-paper': 'Fogli ondulati',
      corner: 'Angoli di cartone',
      alveolar: 'Alveari'
    },
    placeholders: {
      boxAmount: 'Quantità',
      email: 'E-mail'
    },
    props: {
      yes: 'Si',
      no: 'No',
      chooseFile: 'Scegli file',
      length: 'Lato lungo',
      height: 'Altezza',
      depth: 'Lato corto',
      diameter: 'Diametro',
      externalSize: {
        title: 'Esterne',
        description: 'Misure della scatola'
      },
      internalSize: {
        title: 'Interne',
        description: "Misure dell'oggetto da contenere"
      },
      boxOpenings: {
        top: "Dall'alto",
        diagonal: 'Diagonale',
        horizontal: 'Orizzontale',
        frontal: 'Frontale'
      },
      printTypes: {
        noPrinting: 'Senza stampa',
        oneColor: 'Stampa 1 colore',
        twoColors: 'Stampa 2 colore',
        threeColors: 'Stampa 3 colore',
        trichrome: 'Stampa tricromia',
        litography: 'Stampa litografica'
      },
      boxTypes: {
        oneWave: 'Un onda',
        twoWaves: 'Due onde',
        threeWaves: 'Tre onde',
        microWave: 'Microonda',
        lowWave: 'Onda bassa',
        highWave: 'Onda alta',
        microTriple: 'Microtriplo',
        briefCase: 'Valigetta',
        slipCase: 'Cofanetto'
      },
      corrugatedPaperSize: 'Dimensione del foglio: 50 - 120 cm',
      cornerMinSize: 'Dimensione minima: 3,5 cm',
      separators: 'Separatori'
    },
    contact: {
      name: 'Nome e cognome',
      email: 'E-mail',
      phone: 'Numero di telefono',
      street: 'Indirizzo',
      city: 'Città',
      province: 'Provincia',
      fiscalEntity: 'Ragione sociale',
      postalCode: 'Cap',
      emailError: "L'e-mail inserita non è valida"
    }
  }
}
